module.exports = __webpack_public_path__ + "img/logo_horizontal_cor.a0d861f2.png";